<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import { useTypesEdgesModel } from './../model/model.ts'
import type { ObjectTypesEdgesType } from '@/entities/Inventory/ObjectTypesEdges'
import type { PropType } from 'vue'

const props = defineProps({
  item: {
    type: Object as PropType<ObjectTypesEdgesType>,
    required: true,
  },
})

const model = useTypesEdgesModel()

/**
 * Функция обработки открытия окна редактирования
 */
const clickHandler = () => {
  model.item = props.item
  model.open = true
}
</script>

<template>
  <VBtn icon density="compact" @click="clickHandler">
    <VIcons type="instant_mix" />
  </VBtn>
</template>
